import { DataBean } from "../DataBean";

export class CashReimbursementnullify extends DataBean {



    public async nullifyCashReimbursement(idCashReimbursement:any,cashReimbursementDate:any,description:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_nullifyCashReimbursement_Number_java.util.Date_String_Number", [idCashReimbursement,cashReimbursementDate,description,idEmployee]);
    }
    
}